export default "__VITE_ASSET__8c8b7f49__"